// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".details[data-v-1c1ff4d8]{max-width:62.5rem;min-width:59.895833rem;margin:1.041667rem auto}", ""]);
// Exports
module.exports = exports;
